var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4.88636C9.82847 4.88636 9.16351 5.01863 8.5431 5.27562C7.92268 5.5326 7.35896 5.90927 6.88411 6.38411C6.40927 6.85896 6.0326 7.42268 5.77562 8.0431C5.51863 8.66351 5.38636 9.32847 5.38636 10C5.38636 10.6715 5.51863 11.3365 5.77562 11.9569C6.0326 12.5773 6.40927 13.141 6.88411 13.6159C7.35896 14.0907 7.92268 14.4674 8.5431 14.7244C9.16351 14.9814 9.82847 15.1136 10.5 15.1136C11.8562 15.1136 13.1569 14.5749 14.1159 13.6159C15.0749 12.6569 15.6136 11.3562 15.6136 10C15.6136 8.64378 15.0749 7.34311 14.1159 6.38411C13.1569 5.42512 11.8562 4.88636 10.5 4.88636ZM4.25 10C4.25 6.5483 7.0483 3.75 10.5 3.75C13.9517 3.75 16.75 6.5483 16.75 10C16.75 13.4517 13.9517 16.25 10.5 16.25C7.0483 16.25 4.25 13.4517 4.25 10Z",
    fill: "#164B35",
    stroke: "#164B35",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6863 8.2956L9.2965 12.6854L7.09082 10.053L7.94934 9.30866L9.35616 11.0189L12.8829 7.49219L13.6863 8.2956Z",
    fill: "#164B35",
    stroke: "#164B35",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.1cc0936abe05ed0757878194193314ed.svg";
export { ForwardRef as ReactComponent };